/** The one status card (U1 item 5): a centred card of about 560px with an icon, a title, one sentence and the one button. Submitted, paused and waiting states all use it. */
import type { ReactNode } from "react";
import { Icon, type IconName } from "./icons";

export function GxStatusCard({ icon, title, children, detail, action, testId, label, tone = "neutral" }: {
  readonly icon: IconName; readonly title: string;
  /** The one sentence. */ readonly children?: ReactNode;
  /** Anything that sits between the sentence and the button (a progress bar, the plan just submitted). */ readonly detail?: ReactNode;
  /** The primary button (or buttons). */ readonly action?: ReactNode;
  readonly testId?: string; readonly label?: string; readonly tone?: "neutral" | "good";
}) {
  return (
    <section className={`gx-status-card gx-status-card--${tone}`} data-testid={testId} aria-label={label ?? title}>
      <span className="gx-status-icon"><Icon name={icon} size={22} /></span>
      <h2 className="gx-h3">{title}</h2>
      {children === undefined ? null : <p>{children}</p>}
      {detail === undefined ? null : <div className="gx-status-detail">{detail}</div>}
      {action === undefined ? null : <div className="gx-status-acts">{action}</div>}
    </section>
  );
}
